import { render, staticRenderFns } from "./EditPackageForm.vue?vue&type=template&id=3d993876&scoped=true&lang=pug"
import script from "./EditPackageForm.vue?vue&type=script&lang=js"
export * from "./EditPackageForm.vue?vue&type=script&lang=js"
import style0 from "./EditPackageForm.vue?vue&type=style&index=0&id=3d993876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d993876",
  null
  
)

export default component.exports